import React from 'react';
import Button from '../../../../../../components/buttons/Button';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import LabelRenameField from './LabelRenameField';
import { LabelEditContentProps } from '../labelComponentPropTypes';
import LabelDeleteButton from './LabelDeleteButton';

const LabelEditContent: React.FC<LabelEditContentProps> = (props) => {
    const { label, onColorChangeClick, labeledElements } = props;

    const translate = useTranslator('popup', 'labels.edit');

    return (
        <div className="LabelEditContent">
            <Button
                className="flex w-48 !mx-6 !pt-2 !pb-1 !px-4 hover:!bg-gray-100"
                id={`label-color-${label.id}`}
                onClick={onColorChangeClick}
            >
                {translate('changeColor')}
            </Button>
            <LabelDeleteButton label={label} labeledElements={labeledElements} translate={translate} />
            {/* FIXME WEB-15187 (Update label rename logic) */}
            <div className="flex w-48 !mx-6 !pt-1 !pb-2 !px-3">
                <LabelRenameField {...props} />
            </div>
        </div>
    );
};

export default LabelEditContent;
